import { differenceInSeconds } from 'date-fns';

export type RelativeTime =
  | { unit: 'now' }
  | { unit: 'second' | 'minute' | 'hour'; n: number }
  | { unit: 'day' | 'week' | 'month' | 'year'; n: number };

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

export function formatRelativeTime(date: Date, now: Date = new Date()): RelativeTime {
  const diff = Math.abs(differenceInSeconds(now, date));

  if (diff < 5) return { unit: 'now' };
  if (diff < MINUTE) return { unit: 'second', n: Math.floor(diff) };
  if (diff < HOUR) return { unit: 'minute', n: Math.floor(diff / MINUTE) };
  if (diff < DAY) return { unit: 'hour', n: Math.floor(diff / HOUR) };
  if (diff < WEEK) return { unit: 'day', n: round1(diff / DAY) };
  if (diff < MONTH) return { unit: 'week', n: round1(diff / WEEK) };
  if (diff < YEAR) return { unit: 'month', n: round1(diff / MONTH) };
  return { unit: 'year', n: round1(diff / YEAR) };
}

function round1(value: number): number {
  return Math.round(value * 10) / 10;
}
